import DOMPurify from 'dompurify';

/**
 * Sanitize HTML to prevent XSS attacks
 * @param {string} dirtyHTML - HTML string that needs sanitization
 * @returns {string} - Sanitized HTML string safe for dangerouslySetInnerHTML
 */
export const sanitizeHTML = (dirtyHTML) => {
    if (!dirtyHTML) return '';
    
    // Configure DOMPurify to only allow safe tags and attributes
    const config = {
        ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li'],
        ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
        FORCE_BODY: false,
    };
    
    return DOMPurify.sanitize(dirtyHTML, config);
};

/**
 * Create a safe HTML object for dangerouslySetInnerHTML
 * @param {string} html - HTML string to sanitize
 * @returns {Object} - Object suitable for dangerouslySetInnerHTML
 */
export const createSafeHTML = (html) => {
    if (!html) return { __html: '' };
    return { __html: sanitizeHTML(html) };
};

/**
 * Extract plain text from HTML (removes all tags)
 * @param {string} html - HTML string
 * @returns {string} - Plain text content
 */
export const stripHTML = (html) => {
    if (!html) return '';
    const temp = document.createElement('div');
    temp.innerHTML = sanitizeHTML(html);
    return temp.textContent || temp.innerText || '';
};
